module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-confetti-d00446ce50f32e9d878df7f6d832ee35.svg";